// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Mywallet.module.css";
// import Rightcontainer from "../Components/Rightcontainer";
// import { Link, useHistory } from "react-router-dom";
// import axios from "axios";
// import socket from "../Components/socket";
// import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
// import { BsWallet2 } from "react-icons/bs";
// import io from "../Components/socket";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { VscReferences } from "react-icons/vsc";

// const Mywallet = ({ user }) => {
//   // const [user, setUser] = useState();

//   const access_token = localStorage.getItem("token");
//   //   const walletUpdate =()=>{
//   //  io.emit("getprofile", access_token);
//   //   io.on("setProfile", (data) => {
//   //     setUser(data);
//   //   });
//   //   }

//   //   useEffect(()=>{
//   //     walletUpdate()
//   //   },[]);

//   // language
//   const translations = {
//     hi: {
//       wallet: "वॉलेट",
//       history: "इतिहास देखे | ",
//       amount: "पैसे जोड़ें | ",
//       withdraw: "पैसे निकाले  | ",
//       referPerson: "रेफ़रल | ",
//     },
//     en: {
//       wallet: "My Wallet",
//       history: "Order History",
//       amount: "Add Cash",
//       withdraw: "Withdraw",
//       referPerson: "Referral",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   // change theme
//   const theme = localStorage.getItem("theme");

//   const styles = {
//     backgroundColor: theme === "light" ? "#d3e3fd" : "#000",
//     color: theme === "light" ? "black" : "#fff",
//   };

//   return (
//     <>
//       <div
//         className="leftContainer mb_space"
//         style={{ ...styles, height: "100vh" }}
//       >
//         <div className="balance-section pt-2 mt-5 Orher_page_main_section">
//           <div className="mt-2">
//             <h3 className="mb-3">Balance</h3>

//             {/* Deposit Cash Card */}
//             <div className="unique-card">
//               <div className="unique-card-left">
//                 <img src="/images/deposit.png" className="card-main-img" />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Deposit Cash</h2>

//                 <div className="uc-amount">
//                   <img src="/images/rupee.png" className="rupee-icon" />
//                   <b>{user && user.Wallet_balance - user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/addcase">
//                   <button className="uc-btn">
//                     <AiOutlinePlus className="icons" />{" "}
//                     {translations[language].amount}
//                   </button>
//                 </Link>
//               </div>
//             </div>

//             {/* Winning Cash Card */}
//             <div className="unique-card win">
//               <div className="unique-card-left">
//                 <img
//                   src="/images/win-cash.png"
//                   className="card-main-img"
//                   style={{ transform: "scale(1.5)" }}
//                 />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Winning Cash</h2>

//                 <div className="uc-amount text-danger">
//                   <img src="/images/rupee.png" className="rupee-icon" />
//                   <b>{user && user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/Withdrawopt">
//                   <button className="uc-btn withdraw">
//                     <BsWallet2 className="icons" />{" "}
//                     {translations[language].withdraw}
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="rightContainer">
//           <div>
//             <Rightcontainer />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
// export default Mywallet;


import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import Rightcontainer from "../Components/Rightcontainer";
import { FiArrowDownCircle, FiArrowUpCircle } from "react-icons/fi";
import { MdDownload, MdUpload } from "react-icons/md";
const Mywallet = ({ user }) => {
  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      status: "खाता स्थिति",
      verified: "सत्यापन पूरा हुआ",
      deposit: "डिपॉजिट चिप्स",
      winnings: "विनिंग चिप्स",
      availablePlay: "खेलने के लिए उपलब्ध",
      withdrawBal: "निकालने योग्य शेष",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
    },
    en: {
      status: "Account Status",
      verified: "Verification Completed",
      deposit: "Deposit Chips",
      winnings: "Winning Chips",
      availablePlay: "Available for play",
      withdrawBal: "Withdrawable balance",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "Your transactions are 100% secure and encrypted.",
    },
  };

  const t = translations[language] || translations.en;

  const depositAmount = user ? (user.Wallet_balance - user.withdrawAmount).toFixed(2) : "0.00";
  const winningAmount = user ? user.withdrawAmount.toFixed(2) : "0.00";

  return (
    <div className="malik_wallet_page">

      {/* Top Wallet Summary */}
      <div className="malik_wallet_summary">

        <div className="wallet_balance_header">
          <h5>Total Wallet Balance</h5>
          <h1>₹ {Number(depositAmount) + Number(winningAmount)}</h1>
        </div>

        <div className="wallet_stats_grid">

          <div className="wallet_stat_box deposited_box">
            <div className="wallet_stat_icon">
              <MdDownload />
            </div>

            <span>Deposited</span>

            <h3>₹ {depositAmount}</h3>
          </div>

          <div className="wallet_stat_box withdrawn_box">
            <div className="wallet_stat_icon">
              <MdUpload />
            </div>

            <span>Withdrawn</span>

            <h3>₹ {winningAmount}</h3>
          </div>

        </div>

      </div>

      {/* Action Cards */}

      <div className="wallet_action_grid">

        <Link to="/addcase" className="wallet_action_card deposit_action">

          <div className="deposit_plus_badge">
            <span>+</span>
          </div>

          <div className="action_icon">
            💰
          </div>

          <h2>{t.deposit}</h2>

          <p>Add money instantly to your wallet.</p>

        </Link>

        <Link
          to="/Withdrawopt"
          className="wallet_action_card withdraw_action"
        >

          <div className="action_icon">
            🏦
          </div>

          <h2>{t.withdraw}</h2>

          <p>Transfer winnings directly to your bank.</p>

        </Link>

      </div>

    </div>
  );
};

export default Mywallet;